import { NotificationModel } from '../../../shared/data/models/notification.model';

export interface SingleNotificationState {
  notification: NotificationModel;
  loading: boolean;
  error: string;
}

export const initialSingleNotificationState: SingleNotificationState = {
  notification: null,
  error: '',
  loading: false
};
